import React, { ReactNode } from 'react';
import View from '../../atoms/view';
import { FelaExtend, ThemedStyleProps, ThemesProp } from '../../../types/fela';

type SideBarProps = {
  children?: ReactNode;
  extend?: FelaExtend;
  themes: ThemesProp;
  setActive?: boolean;
};

const SideBar = ({ children, extend, themes, setActive = true }: SideBarProps) => {
  const [state] = React.useState(setActive);

  return (
    <View
      extend={
        !state
          ? styles.sidebar_inactive
          : [
              styles.sidebar_active,
              themes.device === 'desktop'
                ? styles.sidebar_desktop
                : themes.device === 'tablet'
                  ? styles.sidebar_tablet
                  : themes.device === 'mobile' && styles.sidebar_mobile,
              extend,
            ]
      }
    >
      {children}
    </View>
  );
};

const styles = {
  sidebar_active: ({ theme: { colors } }: ThemedStyleProps) => ({
    backgroundColor: colors.white,
    flexShrink: 0,
    zIndex: 5,
    borderRight: '1px solid rgb(240, 240, 240)',
    paddingLeft: 8,
    paddingRight: 8,
  }),
  sidebar_inactive: {
    display: 'none',
  },
  sidebar_desktop: () => ({}),
  sidebar_tablet: () => ({}),
  sidebar_mobile: () => ({
    '& .DatePickerContainer': {
      marginLeft: 'auto !important',
      marginRight: 'auto !important',
      width: '100%',
    },
  }),
};

export default SideBar;
